import * as Vue from 'vue'
export default {}
